/* eslint-disable no-restricted-exports, unicorn/no-anonymous-default-export, @typescript-eslint/no-unnecessary-condition */
type BreadCrumb = {
    name: string;
    path: string;
};

const router = useRouter();

export default () => {
    const { t } = useI18n();

    const route = useRoute();

    const breadcrumbs: Ref<BreadCrumb[] | undefined> = ref();

    watchEffect(() => {
        if (route.path === "/") return;

        breadcrumbs.value = getBreadcrumbs(route.path);
    });

    function getBreadcrumbs(currentPath: string): BreadCrumb[] {
        if (currentPath === "") return [{ name: "", path: "" }];

        const parentRoutes = getBreadcrumbs(
            currentPath.slice(0, currentPath.lastIndexOf("/")),
        );

        const route = router.resolve(currentPath);

        const name = ref<string>("");

        if (route.meta?.displayName) {
            name.value = route.meta?.pluralName
                ? t(route.meta?.displayName, 2)
                : t(route.meta?.displayName);

            if ("id" in route.params && route.meta?.hasDisplayId) {
                name.value += ` #${route.params.id}`;
            }
        } else {
            name.value = "";
        }

        return [
            ...parentRoutes,
            {
                name: name.value,
                path: currentPath,
            },
        ];
    }

    return {
        breadcrumbs,
    };
};
